import React, { useState } from "react";
import "../style/login.css";
import Header from "../Layout/Header/Header";
// import logo from "../assets/adminLoginLogo.png";
import logo from "../assets/logo/newLogo.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { loginSuccess } from "../redux/loginSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

// Add this near the top of your component, after the useState declarations
const toastIds = {
  otpSent: 'otp-sent-toast',
  otpVerified: 'otp-verified-toast',
  error: 'error-toast'
};

function LoginPage() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [isOtpSent, setIsOtp] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validationError, setValidationError] = useState({
    mobileNumber: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Add countdown timer effect
  React.useEffect(() => {
    let timer;
    if (isOtpSent && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      setCanResend(true);
    }
    return () => clearInterval(timer);
  }, [isOtpSent, countdown]);

  const handleMobileNumberChange = (e) => {
    // Remove non-numeric characters
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Limit to 10 digits
    const limitedValue = numericValue.slice(0, 10);

    setMobileNumber(limitedValue);
    
    // Validate mobile number (Indian mobile numbers typically start with 6-9)
    if (limitedValue.length === 10 && !/^[6-9]\d{9}$/.test(limitedValue)) {
      setValidationError((prev) => ({
        ...prev,
        mobileNumber: "Invalid mobile number",
      }));
    } else {
      setValidationError((prev) => ({
        ...prev,
        mobileNumber: "",
      }));
    }
    
    // Reset OTP state if mobile number changes
    if (isOtpSent) {
      setIsOtp(false);
    }
  };

  const handleOtpChange = (e) => {
    // Remove non-numeric characters
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Limit to 6 digits
    const limitedValue = numericValue.slice(0, 6);
    setOtp(limitedValue);
  };

  // Handle Get OTP API call
  const handleGetOtp = async (event) => {
    event.preventDefault();
    
    // Check if mobile number is valid
    if (mobileNumber.length !== 10 || validationError.mobileNumber) {
      if (mobileNumber.length !== 10) {
        setValidationError((prev) => ({
          ...prev,
          mobileNumber: "Mobile number must be 10 digits",
        }));
      }
      return;
    }
    
    if (isLoading) return; // Prevent multiple calls while loading
    
    setIsLoading(true);
    const endpoint = `${base_url}/${api_type}/login`;
    try {
      const response = await axios.post(endpoint, {
        mobileNumber: mobileNumber,
      });
      // alert(response.data.message || "OTP sent successfully!");
      // Check if toast exists before showing new one
      if (!toast.isActive(toastIds.otpSent)) {
        toast.success("OTP sent", { toastId: toastIds.otpSent });
      }

      setIsOtp(true);
      setOtp("");
      setCountdown(30);
      setCanResend(false);
    } catch (error) {
      console.error("Error sending OTP:", error);
      if (!toast.isActive(toastIds.error)) {
        toast.error(error.response?.data?.message, { toastId: toastIds.error });
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Verify OTP API call
  const handleVerifyOtp = async (event) => {
    event.preventDefault();

    const endpoint = `${base_url}/${api_type}/verifyOtp`;
    try {
      const response = await axios.post(endpoint, {
        mobileNumber: mobileNumber,
        mobileOtp: otp,
      });
      // alert(response.data.message || "OTP verified successfully!");
      if (!toast.isActive(toastIds.otpVerified)) {
        toast.success("OTP verified successfully", { toastId: toastIds.otpVerified });
      }
            localStorage.setItem("token", response?.data?.data?.userData?.authToken);

      dispatch(
        loginSuccess({
          user: response?.data?.data?.userData,
          token: response?.data?.data?.userData?.authToken,
        })
      );
      // console.log("login response", response);
      // localStorage.setItem("authenticate", true);
    } catch (error) {
      console.error("Error verifying OTP:", error);
      if (!toast.isActive(toastIds.error)) {
        toast.error(error.response?.data?.message, { toastId: toastIds.error });
      }
      // alert(
      //   error.response?.data?.message ||
      //     "Failed to verify OTP. Please try again."
      // );
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    navigate("/dashboard");
  };
  return (
    <div className="">
      <div className="px-16 mt-5">
        <img src={logo} alt="logo" className="w-[150px]" />
      </div>
      <main class="flex h-[60vh] justify-center items-center background-image">
        <div class="">
          <form
            class="form"
            onSubmit={(e) => {
              e.preventDefault();
              if (isOtpSent && otp?.length === 6) {
                handleVerifyOtp(e);
              } else if (!isOtpSent) {
                handleGetOtp(e);
              }
            }}
          >
            <h1 className="text-left text-[#035C98] text-[24px] mb-2">Login</h1>
            <p class="text-[#404041] text-[14px] mb-1">Enter mobile number</p>
            <div class=" flex h-[58px] md:w-[375px] mb-2 rounded-[10px]">
              <select
                className="w-[83px] mr-1 rounded-[10px]"
                disabled={isOtpSent}
              >
                <option value="+91">+91</option>
                <option value="+1">+1</option>
                <option value="+44">+44</option>
              </select>
              <input
                type="tel"
                placeholder="XXXXXXXXXX"
                className="w-full mr-2 rounded-[10px]"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                required
              />
              {!isOtpSent && (
                <button
                  type="button"
                  className="w-[89px] text-white bg-[#035C98] rounded-[10px]"
                  onClick={handleGetOtp}
                  disabled={!mobileNumber || mobileNumber.length !== 10 || validationError.mobileNumber || isLoading}
                >
                  Get OTP
                  {/* {isLoading ? "Get Sent" : "Get OTP"} */}
                </button>
              )}
            </div>
            {validationError.mobileNumber && (
              <p className="text-[#EE4132] mb-2">{validationError.mobileNumber}</p>
            )}
            {isOtpSent && (
              <>
                <div class="h-[58px] flex ">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    maxlength="6"
                    className="w-full rounded-[10px] mr-2"
                    value={otp}
                    // onChange={(e) => setOtp(e.target.value)}
                    onChange={handleOtpChange}
                  />
                   {/* <button
                type="button"
                className="bg-[#035C98] w-[89px] text-white rounded-[10px]"
                onClick={handleVerifyOtp}
                disabled={!otp}
                >
                Verify
                </button> */}
                </div>
                <div className="flex justify-between items-center">
                  <p className="text-blank text-[11px] py-3">
                    A 6-digit OTP will be sent to your mobile number
                  </p>
                  {canResend ? (
                    <button
                      type="button"
                      className="text-[#035C98] text-[12px]"
                      onClick={handleGetOtp}
                    >
                      Resend OTP
                    </button>
                  ) : (
                    <p className="text-black text-[12px]">
                      Resend OTP in {countdown}s
                    </p>
                  )}
                </div>
                {/* <p className=" text-[#B5B5B5] text-[11px] py-3">
                  A 6-digit OTP will be sent to your mobile number
                </p> */}
              </>
            )}
            {isOtpSent && otp?.length === 6 && (
              <button
                type="submit"
                class="submit-btn rounded-[10px]"
                disabled={!isOtpSent && !otp?.length === 6}
              >
                {`Submit`}
              </button>
            )}
          </form>
        </div>
      </main>
    </div>
  );
}

export default LoginPage;
